import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import api from "@/lib/api";

const SiteLayout = () => {
  const [settings, setSettings] = useState(null);
  const location = useLocation();
  // Pages that have a full-bleed image hero — navbar starts transparent (white) and turns solid after scroll
  const TRANSPARENT_ROUTES = ["/", "/destinations", "/vehicles", "/gallery", "/about", "/contact"];
  const transparent = TRANSPARENT_ROUTES.includes(location.pathname);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar settings={settings} transparentOnTop={transparent} />
      <main className="flex-1">
        <Outlet context={{ settings, setSettings }} />
      </main>
      <Footer settings={settings} />
      <WhatsAppFab />
    </div>
  );
};

export default SiteLayout;
